var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDimensions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#272726",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.53 22.47a.926.926 0 0 0-1.308 0L7.4 28.292v-5.167a.925.925 0 0 0-1.85 0v7.4a.925.925 0 0 0 .925.925h7.4a.925.925 0 0 0 0-1.85H8.708l5.82-5.82a.926.926 0 0 0 .002-1.31zM30.878 5.62a.97.97 0 0 0-.353-.07h-7.4a.925.925 0 0 0 0 1.85h5.167l-5.82 5.82a.926.926 0 0 0 1.308 1.31l5.82-5.822v5.167a.925.925 0 0 0 1.85 0v-7.4a.928.928 0 0 0-.572-.855z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.375 0H4.625A4.63 4.63 0 0 0 0 4.625v27.75A4.63 4.63 0 0 0 4.625 37h27.75A4.63 4.63 0 0 0 37 32.375V4.625A4.63 4.63 0 0 0 32.375 0zm2.775 32.375a2.778 2.778 0 0 1-2.775 2.775H4.625a2.778 2.778 0 0 1-2.775-2.775V4.625A2.778 2.778 0 0 1 4.625 1.85h27.75a2.778 2.778 0 0 1 2.775 2.775v27.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensions);
export default __webpack_public_path__ + "static/media/dimensions.d4217dbe984d1707b6de9e8badb1dd90.svg";
export { ForwardRef as ReactComponent };